import { useIntl } from '@/intl'
import { Button, Icon, Typography } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

interface GoBackProps {
  onClick?: () => void
}

const Btn = styled(Button)`
  width: fit-content;
`

export function GoBack({ onClick = () => {} }: GoBackProps) {
  const intl = useIntl()
  const handleGoBack = () => {
    onClick()
    /// TODO: Remove when PDP is full REACT
    const currentUrl = window.location.href
    const url = currentUrl.split('#')[0]
    window.location.href = `${url}#acco-tab-01d38658-0bf9-4ef9-898d-5acbdb329b6d`
  }
  return (
    <Btn data-qa="go-back-btn" $hierarchy="tertiary" $withoutColor onClick={() => handleGoBack()}>
      <Icon glyph="IconChevronLeft" />
      <Typography $variant="body-md-bold">{intl.formatMessage({ id: 'prices_go-back' })}</Typography>
    </Btn>
  )
}
